import { imagePositionStyle } from "../lib/imagePosition";
import { navigate } from "../lib/router";
import type { Board } from "../lib/types";

interface BoardCardProps {
  board: Board;
}

export function BoardCard({ board }: BoardCardProps) {
  const imageScale = board.coverImageScale ?? 1;
  const imageOffsetX = board.coverImageOffsetX ?? 0;
  const imageOffsetY = board.coverImageOffsetY ?? 0;

  return (
    <article
      className="board-card panel-surface grid grid-cols-[auto_1fr] items-center overflow-hidden rounded-[14px] cursor-pointer"
      onClick={() => navigate(`/boards/${board.id}`)}
    >
      <div
        className="w-24 aspect-[4/3] overflow-hidden product-image-bg relative"
        data-testid="board-card-cover"
      >
        {board.coverImageUrl ? (
          <img
            className="w-full h-full object-cover"
            src={board.coverImageUrl}
            alt=""
            draggable={false}
            style={imagePositionStyle(imageScale, imageOffsetX, imageOffsetY)}
          />
        ) : (
          <div className="w-full h-full" />
        )}
      </div>
      <div className="flex flex-col justify-center px-4">
        <span className="font-semibold">{board.label}</span>
        {board.ownerUsername && (
          <span className="text-xs text-muted mt-0.5">@{board.ownerUsername}</span>
        )}
      </div>
    </article>
  );
}
